import { condofyProtected } from './instance';

export const getBillingInfo = (id) => condofyProtected.get(`v1/invoices/${id}`);
